import bootLayout from 'static/script/app/boot/boot-layout';
import KlarnaPinUI from 'static/script/app/ui/cart-paypal-payment-ui';

export default initData => {
    bootLayout(initData);
    KlarnaPinUI.attachTo('[data-paypal-payment]');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/cart-paypal-payment.js